import type { ArdoqId } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import type { GraphComponent } from '@ardoq/yfiles';
import {
  metamodelSlideContainerRegistered,
  metamodelSlideContainerUnregistered,
  metamodelSlideGraphComponentRegistered,
  metamodelSlideGraphComponentUnregistered,
} from 'presentation/viewPane/slideCaptureSurface$';

export const toRegisterGraphComponent =
  (metamodelId: ArdoqId): ((graphComponent: GraphComponent) => void) =>
  graphComponent =>
    dispatchAction(
      metamodelSlideGraphComponentRegistered({ graphComponent, metamodelId })
    );

export const unregisterGraphComponent = (): void =>
  dispatchAction(metamodelSlideGraphComponentUnregistered());

export const registerVisualizationContainer = (container: HTMLElement): void =>
  dispatchAction(metamodelSlideContainerRegistered(container));

export const unregisterVisualizationContainer = (): void =>
  dispatchAction(metamodelSlideContainerUnregistered());
